// extracted by mini-css-extract-plugin
export default {"item":"event-dates_item__2PmXd","date":"event-dates_date__1-lzY"};